import { useHasBillingManagementActive, useHasNFSeProductActive } from '@ibk/shared-config';
import { FeatureFlagUseCase } from '@ibk/shared-types';
import { useFeatureFlag } from '../useFeatureFlag/useFeatureFlag';
export const useNFSeAccess = (isAuthenticated) => {
    const { isFeatureFlagWhiteListed, isLoading: isLoadingFeatureFlags } = useFeatureFlag(undefined, {
        isLoggedIn: isAuthenticated,
    });
    const isNFSeModuleEnabled = !!isFeatureFlagWhiteListed(FeatureFlagUseCase.MODULE_BILLING_NFSE);
    const isNFSeStandaloneEnabled = !!isFeatureFlagWhiteListed(FeatureFlagUseCase.MODULE_BILLING_NFSE_STANDALONE);
    const { hasBillingActive: hasBillingManagementActive, isLoading: isLoadingBillingManagementActive } = useHasBillingManagementActive();
    const { hasNFSeProductActive } = useHasNFSeProductActive();
    const canAccessNFSe = isNFSeModuleEnabled && (isNFSeStandaloneEnabled || hasBillingManagementActive);
    const isLoadingAccess = isLoadingFeatureFlags || (!isNFSeStandaloneEnabled && isLoadingBillingManagementActive);
    const shouldRedirectFromNFSe = !isLoadingAccess && !canAccessNFSe;
    return {
        isNFSeModuleEnabled,
        isNFSeStandaloneEnabled,
        hasBillingManagementActive,
        hasNFSeProductActive,
        isLoadingFeatureFlags,
        isLoadingBillingManagementActive,
        isLoadingAccess,
        canAccessNFSe,
        shouldRedirectFromNFSe,
    };
};
